/* eslint-disable no-nested-ternary */
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import { Grid } from '@mui/material';
import Storage from 'src/utils/storage/storage';
import { useState } from 'react';
import { useAppSelector } from 'src/hooks';
import {
  Header,
  InputType,
  TableComponent
} from '../../../../pricing-simulator/types/generic-table.model';

export default function getColumnForPhRecomType(
  columnData: Header,
  moduleId: number,
  sourceId: number,
  scenarioId: number,
  isDisplayHeader?: boolean,
  maxVal?: number,
  componentType?: any
  // footerRows?: any[] = []
) {
  // style for DT column
  const phColumnStyle = {
    fontWeight: 600,
    textAlign: 'center'
  };
  return {
    accessorKey: columnData.parent.parent_field,
    id:
      columnData.parent.parent_field !== ''
        ? columnData.parent.parent_field
        : columnData.parent.order,

    cell: (info) => {
      // getting the ph recommendation map config data from local storage (as it will be accessible on refresh as well)
      const phRecommendationConfig = Storage.getPhRecommendationLegend();

      // getting the details as per current ph recommendation value
      const phConfig =
        phRecommendationConfig[info.row.original.ph_recommendation] || {};
      // deconstructing alias & color from phConfig with default values as empty string
      const { alias = '', color = '' } = phConfig;

      return (
        <div style={{ color, textAlign: 'center', fontWeight: 600 }}>
          {alias || info.row.original.temp_ph_recommendation}
        </div>
      );
    },

    meta: {
      className: ''
    },
    header: () => (
      <Grid container alignItems='center' flexDirection='column'>
        <Grid
          item
          xs='auto'
          container
          alignItems='center'
          className='change-text'
        >
          {isDisplayHeader ? (
            <Grid item sx={{ cursor: 'pointer' }}>
              <span id='dt-header'>{columnData.parent.alias}</span>
              {getHeaderName(columnData)}
            </Grid>
          ) : null}
        </Grid>
      </Grid>
    )
  };
}
